import React, {FC} from 'react';
import {useAdmins} from "../redux/admins.hook";
import {CreateAdminDialogForm} from "../form/CreateAdminFormDialog";
import {AdminsTable} from "../table/AdminsTable";

export const AdminsScreen: FC = () => {
    const {admins, loading} = useAdmins();
    return (
        <div>
            <div style={{ paddingBottom: 24 }}>
                <CreateAdminDialogForm/>
            </div>
            <AdminsTable admins={admins} loading={loading}/>
        </div>
    );
}